/**
 * Shared focus ring styles for keyboard-only focus visibility.
 * Apply via cn() in component className.
 */
export const focusVisibleStyles =
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background';

/**
 * Wraps an animation class with a motion-reduce fallback.
 * Components use this to respect `prefers-reduced-motion`.
 */
export function motionSafe(animationClass: string): string {
  return `${animationClass} motion-reduce:animate-none`;
}
